/**
 * Temporary intake option restrictions. Clear these sets (or delete this file) to restore
 * all choices. Used by step 0 (therapy type), step 4 (format), and step 8 (payment).
 */
import type { FormatPreference, PayType, TherapyType } from './types';

/** Step 0 — therapy types hidden/disabled for now. */
export const INTAKE_DISABLED_THERAPY_TYPES: ReadonlySet<TherapyType> = new Set([
  'iop',
  'medication',
]);

/** Step 4 — format preferences disabled except virtual. */
export const INTAKE_DISABLED_FORMAT_PREFERENCES: ReadonlySet<FormatPreference> = new Set([
  'in-person',
  'hybrid',
  'no-preference',
]);

/** Step 8 — pay types disabled except cash (out of pocket). */
export const INTAKE_DISABLED_PAY_TYPES: ReadonlySet<PayType> = new Set([]);

export function isTherapyTypeIntakeDisabled(value: TherapyType): boolean {
  return INTAKE_DISABLED_THERAPY_TYPES.has(value);
}

export function isFormatPreferenceIntakeDisabled(value: FormatPreference): boolean {
  return INTAKE_DISABLED_FORMAT_PREFERENCES.has(value);
}

export function isPayTypeIntakeDisabled(value: PayType): boolean {
  return INTAKE_DISABLED_PAY_TYPES.has(value);
}
